'use strict';
const aircraftmapConstants = require('components/bags_and_seats/aircraftmap_utils/js/aircraftmap.constants');

const defaults = {
    seatStatus: {
        unavailable: 'unavailable',
        no_seat: 'no_seat',
        aisle: 'available',
        window: 'available',
        middle: 'available',
    },
    keys: {},
    seatMap: {},
};

let options = {};

module.exports = {
    defaults: defaults,
    constants: aircraftmapConstants,
    options: options,
    parseOptions: function(options) {
        return Odigeo._.extend({}, defaults, options);
    },
    isNoSeat: function(seat) {
        return Odigeo._.get(seat, 'type') === this.options.seatStatus.no_seat;
    },
    isSeatLavatory: function(characteristics) {
        return Odigeo._.contains(characteristics, this.constants.LAVATORY);
    },
    getNoSeatType: function(characteristics) {
        if (this.isSeatLavatory(characteristics)) {
            return 'od-aircraftmap-noseat-lavatory odf-icon-lavatory ';
        }
        return '';
    },
    hasExtraLegCharacteristic: function(seat) {
        const characteristic = Odigeo._.get(seat, 'characteristics.characteristic');
        return Odigeo._.contains(characteristic, this.constants.EXTRA_LEG);
    },
    hasPreferredSeatCharacteristic: function(seat, threshold) {
        return threshold > 0 && Odigeo._.get(seat, 'rawPrice') >= threshold;
    },
    isCheaperSeatCharacteristic: function(seat, cheaperSeatPrice, differentSeatPrices) {
        return Odigeo._.get(seat, 'rawPrice') === cheaperSeatPrice && Odigeo._.size(differentSeatPrices) >= 2;
    },

    getSeatByClasses: function($el, seatClasses) {
        let $targetSeat;
        for (let i = 0; (!$targetSeat || !$targetSeat.length) && i < seatClasses.length; i++) {
            const seatClass = seatClasses[i];
            try {
                $targetSeat = $el.find(seatClass).first();
            } catch (e) {
                $targetSeat = null;
            }
        }

        return $targetSeat;
    },
    getLastSeatSelectionType: function($el, selector) {
        const data = $el.find(selector).toArray().reduce((acc, e) => {
            const seatRawPrice = +$(e).data('rawprice');
            const update = !acc.highestPrice || seatRawPrice > acc.highestPrice;
            if (update) {
                acc.highestPrice = seatRawPrice;
                acc.char = $(e).data('characteristic');
            }
            return acc;
        }, {
            highestPrice: 0,
            characteristic: '',
        });

        return data.char;
    },

    getExtraLegClasses: function() {
        return `${this.constants.EXTRA_JS_CLASS} ${this.constants.EXTRA_OD_CLASS} ${this.constants.EXTRA_ICON_CLASS}`;
    },
    getPreferredSeatClasses: function() {
        return `${this.constants.PREFERRED_JS_CLASS} ${this.constants.PREFERRED_OD_CLASS} ${this.constants.PREFERRED_ICON_CLASS}`;
    },
    getCheaperSeatClasses: function() {
        return `${this.constants.SMART_JS_CLASS} ${this.constants.SMART_OD_CLASS} ${this.constants.SMART_ICON_CLASS}`;
    },
    getSeatCharacteristicClasses: function(seat, aircraftInfo) {
        const preferredSeatThreshold = Odigeo._.get(aircraftInfo, 'preferredSeatsThreshold', '');
        if (this.isNoSeat(seat)) {
            return this.constants.STANDARD_JS_CLASS;
        }
        if (this.hasExtraLegCharacteristic(seat)) {
            return this.getExtraLegClasses();
        }
        if (this.hasPreferredSeatCharacteristic(seat, preferredSeatThreshold)) {
            return this.getPreferredSeatClasses();
        }
        if (
            this.isCheaperSeatCharacteristic(
                seat,
                aircraftInfo.cheaperSeatPrice,
                aircraftInfo.differentSeatPrices
            )
        ) {
            return this.getCheaperSeatClasses();
        }
        return this.constants.STANDARD_JS_CLASS;
    },
    getSeatMainCharacteristic: function(seat, aircraftInfo) {
        return this.isNoSeat(seat)
            ? this.constants.STANDARD_TYPE
            : this.hasExtraLegCharacteristic(seat)
                ? this.constants.EXTRA_LEG_TYPE
                : this.hasPreferredSeatCharacteristic(seat, Odigeo._.get(aircraftInfo, 'preferredSeatsThreshold'))
                    ? this.constants.PREFERRED_TYPE
                    : this.isCheaperSeatCharacteristic(
                        seat,
                        Odigeo._.get(aircraftInfo, 'cheaperSeatPrice'),
                        Odigeo._.get(aircraftInfo, 'differentSeatPrices')
                    )
                        ? this.constants.CHEAPER_TYPE
                        : this.constants.STANDARD_TYPE;
    },
    getSectionPreferredThreshold: function(sectionId, thresholds) {
        return Odigeo._.get(thresholds, sectionId, 0);
    },
    getSeatRow: function(seats) {
        return Odigeo._.find(seats, function(seat) {
            return seat.seatRow !== this.constants.BLANK_SEATS;
        }, this).seatRow;
    },
    getSeatCharacteristicClassByType: function(seatType, classType) {
        if (typeof seatType === 'string') {
            const seatTypeUppercase = seatType.toUpperCase();
            const constClassId = `${seatTypeUppercase}_${classType === 'icon' ? 'ICON' : 'JS'}_CLASS`;
            return Odigeo._.get(this.constants, constClassId, '');
        }
        return '';
    },
    isRowWithoutSeats: function(seats) {
        return Odigeo._.size(Odigeo._.filter(seats, {seatRow: this.constants.BLANK_SEATS}, this)) === Odigeo._.size(seats);
    },
    isExitRow: function(exitRows, seatRow) {
        return Odigeo._.gt(Odigeo._.indexOf(exitRows, seatRow), -1);
    },
    isSeatExtraLeg: function(extraLegSeats, seatRow, column) {
        return Odigeo._.gt(Odigeo._.indexOf(extraLegSeats, seatRow + column), -1);
    },
    getCustomRowElement: function(customElement, separator) {
        return Odigeo._.isString(customElement) ? customElement.split(separator) : '';
    },
    getSeatRowFromSeatMapRow: function(cabin, seatMapRow) {
        const seatsInRow = Odigeo._.filter(cabin.seats.seat, {seatMapRow: seatMapRow});
        if (Odigeo._.size(seatsInRow) > 0) {
            return this.isRowWithoutSeats(seatsInRow) ? this.findLavatories(seatsInRow) : this.getSeatRow(seatsInRow);
        }
        return this.constants.NO_SEATS;
    },
    findLavatories: function(seats) {
        return this.rowContainsLavatories(seats) ? this.constants.BLANK_SEATS : this.constants.EMPTY_ROW;
    },
    rowContainsLavatories: function(seats) {
        return Odigeo._.some(seats, function(seat) {
            return !Odigeo._.isUndefined(seat.seatCharacteristics.characteristic) && this.isSeatLavatory(seat.seatCharacteristics.characteristic);
        }, this);
    },
    addExitRow: function(seatRow) {
        return $('<div>', {class: 'od-exit-row-color aircraftmap_exit_row od-aircraftmap-exit-row'})
            .attr('data-exit-row', seatRow)
            .append($('<div>', {class: 'odf-icon odf-icon-bidi od-exit-row-icon odf-text-lg odf-icon-arrow-left-double od-exit-row-icon-left'}))
            .append($('<div>', {class: 'odf-icon odf-icon-bidi od-exit-row-icon odf-text-lg odf-icon-arrow-right-double od-exit-row-icon-right'}));
    },
    getSeatCharacteristics: function(cabin, seatRow, seatMapRow, column) {
        let seat = Odigeo._.find(cabin.seats.seat, {seatMapRow: seatMapRow, column: column});
        if (Odigeo._.isUndefined(seat)) {
            seat = Odigeo._.find(cabin.seats.seat, {seatRow: this.constants.BLANK_SEATS, seatMapRow: seatMapRow, column: column}, this);
        }
        const isFound = !Odigeo._.isUndefined(seat);
        const type = isFound ? seat.type.toLowerCase() : this.options.seatStatus.unavailable;
        const price = isFound ? Odigeo.Utils.formatCurrency(seat.totalPrice) : '';
        const primePrice = isFound ? Odigeo.Utils.formatCurrency(seat.totalPrimePrice) : '';
        const rawPrice = isFound ? seat.totalPrice : '';
        const rawPrimePrice = isFound ? seat.totalPrimePrice : '';
        const characteristics = isFound ? seat.seatCharacteristics : [];
        return {
            row: seatRow,
            seatMapRow: seatMapRow,
            characteristics: characteristics,
            column: column,
            type: type,
            status: this.options.seatStatus[type],
            key: this.options.keys[type],
            price: price,
            rawPrice: rawPrice,
            primePrice: primePrice,
            rawPrimePrice: rawPrimePrice,
        };
    },
    addDarkZone: function(cabin) {
        const firstUnavailableRow = cabin.lastSeatsRow + 1;
        const lastUnavailableRow = cabin.lastSeatsRow + this.getNumRowsBetweenNeighborCabins(cabin);
        const key = Odigeo._.gt(this.getNumRowsBetweenNeighborCabins(cabin), 1) ? 'darkzoneMultiRow' : 'darkzoneSingleRow';
        const message = Odigeo._.gt(this.getNumRowsBetweenNeighborCabins(cabin), 1)
            ? Odigeo.Utils.replaceCmsKeyArgs(this.options.keys[key], firstUnavailableRow, lastUnavailableRow)
            : Odigeo.Utils.replaceCmsKeyArgs(this.options.keys[key], firstUnavailableRow);

        return $('<div>', {class: 'od-aircraftmap-darkzone odf-text-sm'}).text(message);
    },
    getNumRowsBetweenNeighborCabins: function(cabin) {
        const cabins = this.options.seatMap.cabin;
        const nextElementIndex = Odigeo._.findIndex(cabins, cabin) + 1;
        const nextElement = cabins[nextElementIndex];
        return !Odigeo._.isUndefined(nextElement) ? (nextElement.firstSeatsRow - cabin.lastSeatsRow - 1) : 0;
    },
    isLastCabin: function(cabin) {
        return Odigeo._.eq(Odigeo._.last(this.options.seatMap.cabin), cabin);
    },
    hasToShowDarkZone: function(cabin) {
        return Odigeo._.gt(Odigeo._.size(this.options.seatMap.cabin), 0) && this.areSpacesBetweenCabins(cabin) && !this.isLastCabin(cabin);
    },
    aircraftContainsDarkZones: function(aircraftData) {
        return Odigeo._.gt(Odigeo._.size(aircraftData.cabin), 1) && Odigeo._.reduce(aircraftData.cabin, function(darkZoneFound, cabin) {
            return darkZoneFound || this.hasToShowDarkZone(cabin);
        }, false, this);
    },
    isExtraLegSeat: function($seat) {
        return $seat.find('.aircraftmap_extra_leg_room').length > 0;
    },
    isEmergencyExitSeat: function($seat) {
        return $seat.parent().hasClass('emergency_exit');
    },
    areSpacesBetweenCabins: function(cabin) {
        return !this.isLastCabin(cabin) && Odigeo._.gt(this.getNumRowsBetweenNeighborCabins(cabin), 0);
    },
    getSeatCountByType: function($aircraft) {
        return {
            preferred: $aircraft.find(`.${this.constants.PREFERRED_JS_CLASS}`).length,
            extra: $aircraft.find(`.${this.constants.EXTRA_JS_CLASS}`).length,
            smart: $aircraft.find(`.${this.constants.SMART_JS_CLASS}`).length,
            standard: $aircraft.find(`.${this.constants.STANDARD_JS_CLASS}`).length,
        };
    },
    getSeatTypeAvailable: function($aircraft) {
        const seatCountByType = this.getSeatCountByType($aircraft);
        return {
            preferred: seatCountByType.preferred > 0,
            extra: seatCountByType.extra > 0,
            smart: seatCountByType.smart > 0,
            standard: seatCountByType.standard > 0,
        };
    },
    setSeatPriceData: function(cabins) {
        const seats = Odigeo._.reduce(cabins, function(seats, cabin) {
            const seatsAvailable = Odigeo._.filter(cabin.seats.seat, function(seat) {
                return seat.type !== 'NO_SEAT';
            });
            return seats.concat(seatsAvailable);
        }, []);

        Odigeo._.extend(this.options, {
            differentSeatPrices: Odigeo._.uniq(seats, 'totalPrice'),
            cheaperSeatPrice: Odigeo._.min(Odigeo._.map(seats, 'totalPrice')),
        });
    },
    isUnavailableOrNoSeat: function(seat) {
        return this.isNoSeat(seat) || seat.type === this.options.seatStatus.unavailable;
    },
};
